import { render, staticRenderFns } from "./DashboardAcessosTotalAcessos.vue?vue&type=template&id=6ba9fb62&scoped=true&"
import script from "./DashboardAcessosTotalAcessos.vue?vue&type=script&lang=js&"
export * from "./DashboardAcessosTotalAcessos.vue?vue&type=script&lang=js&"
import style0 from "./DashboardAcessosTotalAcessos.vue?vue&type=style&index=0&id=6ba9fb62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba9fb62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VCardTitle,VIcon})
